"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgCloseSquare = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "M3.526 3.687C4.534 2.606 5.97 2 7.666 2h8.668c1.7 0 3.137.606 4.144 1.687C21.479 4.762 22 6.247 22 7.917v8.167c0 1.669-.521 3.154-1.523 4.23C19.47 21.394 18.034 22 16.334 22H7.665c-1.7 0-3.135-.605-4.142-1.687C2.522 19.238 2 17.753 2 16.084V7.916c0-1.669.524-3.154 1.526-4.23Zm1.098 1.022c-.7.752-1.124 1.85-1.124 3.207v8.168c0 1.359.422 2.457 1.12 3.207.694.745 1.716 1.21 3.045 1.21h8.669c1.33 0 2.352-.465 3.046-1.21.699-.75 1.12-1.848 1.12-3.207V7.916c0-1.358-.421-2.456-1.12-3.207-.694-.745-1.716-1.209-3.046-1.209H7.665c-1.324 0-2.346.464-3.041 1.21Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M10.132 9.063a.75.75 0 0 0-1.061 1.06l1.867 1.868-1.865 1.866a.75.75 0 0 0 1.06 1.06L12 13.052l1.868 1.868a.75.75 0 1 0 1.06-1.06L13.06 11.99l1.866-1.866a.75.75 0 0 0-1.06-1.06l-1.867 1.866-1.867-1.868Z", fill: "currentColor" })] }))); };
exports.default = SvgCloseSquare;
